export const contactContent = {
  hero: {
    title: "The Soil Signal",
    subtitle: "Join our decentralized community. We are listening."
  },
  invitation: "Whether you're a farmer, an artist, or a supporter, we want to hear from you. Join our decentralized community providing soil centric solutions for food system security. Use this form to reach out about certifications, partnerships, or general inquiries.",
  form: {
    success: {
      title: "Message Planted",
      desc: "Received. The soil thanks you."
    },
    options: [
      { label: "General Inquiry", value: "general" },
      { label: "Certification", value: "certification" },
      { label: "Partnership", value: "partnership" },
      { label: "Press", value: "press" }
    ]
  },
  closing: "Connection is the first step of regeneration"
};